import { Card, CardContent, Stack, Typography } from '@mui/material';
import Grid from '@mui/material/Grid';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import { cardStyles, metaStripStyles } from './eventDetailsStyles';

const formatCategoryLabel = (category) => {
  if (!category) return 'Event';
  return String(category)
    .replace(/[_-]/g, ' ')
    .trim()
    .replace(/\b\w/g, (char) => char.toUpperCase());
};

const EventDateCard = ({ start, end, category = '' }) => (
  <Card sx={{ ...cardStyles.section, bgcolor: '#f8f9fa' }}>
    <CardContent>
      <Grid container spacing={2}>
        <Grid size={{ xs: 12, md: 6 }}>
          <Stack direction="row" spacing={1} alignItems="center">
            <CalendarMonthIcon sx={metaStripStyles.icon} />
            <Typography variant="body2" sx={{ fontWeight: 700 }}>{`${formatCategoryLabel(category)} Start:`}</Typography>
            <Typography variant="body2">{start}</Typography>
          </Stack>
        </Grid>
        <Grid size={{ xs: 12, md: 6 }}>
          <Stack direction="row" spacing={1} alignItems="center">
            <CalendarMonthIcon sx={metaStripStyles.icon} />
            <Typography variant="body2" sx={{ fontWeight: 700 }}>{`${formatCategoryLabel(category)} End:`}</Typography>
            <Typography variant="body2">{end}</Typography>
          </Stack>
        </Grid>
      </Grid>
    </CardContent>
  </Card>
);

export default EventDateCard;
